import { createContext, useContext } from "react";

// True on the activity detail page (ActivityPage). That page is the print view
// ("Druckansicht") of an activity, but also the normal landing page for
// permalinks and notifications. Print-only content (e.g. the full text behind
// a teaser) is only rendered here; everywhere else (e.g. the stream) the
// screen does not carry hidden print copies.
const ActivityPrintViewContext = createContext(false);

// Print-only images are loaded eagerly only while the page is actually opened
// for printing via the "Druckansicht" flow (/activities/:id#print), where
// ActivityPage waits for the images before calling window.print(). On a normal
// visit of the detail page they stay lazy, so the screen does not download
// images it never shows; the "Druckansicht" menu entry there switches them to
// eager before printing (waitForActivityImages). Ctrl+P may miss tiles that
// have not been loaded yet.
export function useEagerPrintImages(): boolean {
  const isPrintView = useContext(ActivityPrintViewContext);
  return isPrintView && window.location.hash === "#print";
}

export default ActivityPrintViewContext;
